import type { BonusPreviewProps } from '../../../context/types'

export const setInitialValues = (data: BonusPreviewProps) => {
  return {
    consumptionTotal: data.previewConsumptionAmount ? data.previewConsumptionAmount.toFixed(2) : 0,
    bonificationTotal: data.previewBonusAmount ? data.previewBonusAmount.toFixed(2) : 0,
    bonificationPercentage: data.previewPercentage ? data.previewPercentage : '',
    deviation: data.deviationPercentage ? `${data.deviationPercentage.toFixed(2)}`.replace('.', ',') : '',
    adjustment: data.adjustmentPercentage ? `${data.adjustmentPercentage.toFixed(2)}`.replace('.', ',') : '',
    observations: data.observation || ''
  }
}
